<template>
  <VUEModal v-if="Popup" :Titolo="'Conferma'" :Programma="Programma" :Altezza="'100px'" :Larghezza="'500px'"
            @onClickChiudiModal="ChiudiPopup" @onClickConfermaModal="ConfermaPopup">
    <template v-slot:Body>
      <p>{{Richiesta}}</p>
    </template>
    <template v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:20%" @click="ChiudiPopup" data-dismiss="modal">No</button>
      <button type="button" class="btn btn-success" style="float:right;font-weight:bold;width:20%" @click="ConfermaPopup" data-dismiss="modal">Sì</button>
    </template>
  </VUEModal>
</template>

<script>

/*Versione 1.0.1 - 09 Novembre 2023 - Francesco Ardini
                 - FIX: rimossi campi inutilizzati
  Versione 1.0.0 - 11 Ottobre 2023 - Francesco Ardini
                 - Prima Versione*/

import VUEModal from './/VUEModal.vue';
export default 
{
  data()
  {
   return {}
  },
  props : ['Richiesta', 'Popup', 'Programma'],
  emits : ['OnClickChiudiPopup', 'OnClickConfermaPopup'],
  components: { VUEModal },
  methods :
  {
    ConfermaPopup()
    {
        this.$emit('OnClickConfermaPopup')
    },
    ChiudiPopup()
    {
        this.$emit('OnClickChiudiPopup')
    }
  }
}
</script>
